export default __webpack_public_path__ + "static/media/sidebar-3.6b8f4e2b.jpg";